import {
  Component,
  Element,
  Fragment,
  getAssetPath,
  h,
  Host,
  Listen,
  Prop,
  State,
} from '@stencil/core';

import wcShared from '@web-components/shared';

import { IReportingToolsCurrentGroup, IReportingToolsUser } from '../models/typing';
import { ReportService } from '../services/report.service';
import { UserService } from '../services/user.service';
import bugInformationsStore from '../stores/bugInformations.store';
import commonStore from '../stores/common.store';
import formStore from '../stores/form.store';

@Component({
  tag: 'module-reporting-tools-component',
  styleUrl: 'main-reporting-tools.scss',
  shadow: true,
})
export class ModuleReportingTools {
  @Prop() readonly triggerOnly: boolean = false;
  @Prop() readonly size: number;

  @State() canBeDisplayed = true;
  @State() openMainModal = false;
  @State() loading = false;
  @State() user: IReportingToolsUser;
  @State() isAutologged = false;

  private currentGroup: IReportingToolsCurrentGroup;
  private hasLogoSlot = false;

  @Element() hostElement: HTMLModuleReportingToolsComponentElement;

  componentWillLoad() {
    if (!window['WC_MODULES_COMMON'].includes('reporting-tools')) {
      this.canBeDisplayed = false;
      return null;
    }
    wcShared.displayComponent('reporting-tools');

    this.hasLogoSlot = Boolean(this.hostElement.querySelector('[slot="trigger"]'));

    formStore.isPartner =
      wcShared.store.currentAccount?.is_partner && !wcShared.store.userStartConfig?.is_staff;
  }

  /*
        put document.dispatchEvent(new CustomEvent('openReportingToolWC')); in the console to open the reporting-tool
   */
  @Listen('openReportingToolWC', { target: 'document' })
  onOpenEvent() {
    if (!commonStore.state.displayModal) this.triggerMainModal();
  }

  @Listen('keydown', { target: 'window' })
  onKeyDown(e) {
    if (!commonStore.state.displayModal && e.altKey && e.code === 'KeyB') this.triggerMainModal();
  }

  private triggerMainModal = (): void => {
    commonStore.state.displayModal = !commonStore.state.displayModal;
    this.loading = true;
    ReportService.getBuckets();
    this.getUser().then(() => {
      this.getBugInformations();
      this.loading = false;
    });
  };

  private stopRecording = (): void => {
    commonStore.state.onRecording = false;
  };

  /* -------------------------------------------------------------------------- */
  /*                              BUGS INFORMATIONS                             */
  /* -------------------------------------------------------------------------- */

  private getUser(): Promise<{
    user: IReportingToolsUser;
    current_group: IReportingToolsCurrentGroup;
    autologged?: boolean;
  }> {
    return UserService.getUser().then((user) => {
      this.user = user.user;
      this.currentGroup = user.current_group;
      this.isAutologged = user.autologged;
      return user;
    });
  }

  private getBugInformations(): void {
    bugInformationsStore.userAgent = window.navigator.userAgent;
    bugInformationsStore.lang = window['CONST_LANG']?.shortcode
      ? window['CONST_LANG']?.shortcode
      : navigator.language;
    bugInformationsStore.pageUrl = window.location.href;
    bugInformationsStore.window = window;
    bugInformationsStore.user = this.user;
    bugInformationsStore.group = this.currentGroup;
    bugInformationsStore.screenSize = window.screen;
  }

  render() {
    if (!this.canBeDisplayed) {
      return null;
    }

    return (
      <Host>
        <div class={`theme-${wcShared?.store?.theme}`}>
          <div
            onClick={this.stopRecording}
            class={{ onRecording: true, hide: !commonStore.state.onRecording }}
          >
            <img
              src={getAssetPath('./../assets/images/recording-pulse.svg')}
              width="80"
              alt="Recording"
            />
            <span class="record-time">{30 - commonStore.state.recordingTime}</span>
          </div>
          {/*This condition hide the bug tracker icon if we are in a ksuite sub-app. It also hide it if*/}
          {/*the reporting tools is directly in the body.*/}
          {/*Having the reporting tools derectly in the body means that we must not show it*/}
          {!wcShared.store.ksuiteBridge?.isConnected &&
            this.hostElement.parentElement !== document.body && (
              <div
                onClick={this.triggerMainModal}
                class={{
                  'reporting-tools-logo': !formStore.isPartner && !this.hasLogoSlot,
                  'reporting-tools-partner-logo': formStore.isPartner && !this.hasLogoSlot,
                  hide: commonStore.state.onRecording,
                }}
              >
                {this.hasLogoSlot ? (
                  <slot name="trigger"></slot>
                ) : formStore.isPartner ? (
                  <img
                    src={getAssetPath('./../assets/images/computer-bug.svg')}
                    alt="Reporting-tools logo"
                  />
                ) : Boolean(this.size) ? (
                  <img
                    width={this.size}
                    height={this.size}
                    src={getAssetPath('./../assets/images/mini-monster.png')}
                    alt="Reporting-tools logo"
                  />
                ) : (
                  <img
                    class="without-custom-size"
                    src={getAssetPath('./../assets/images/mini-monster.png')}
                    alt="Reporting-tools logo"
                  />
                )}
              </div>
            )}
          <div
            class={{
              'recording-header': true,
              hide: !commonStore.state.onRecording,
            }}
          >
            {wcShared.translate('Votre ecran est en cours denregistrement video')}
          </div>
          {!this.triggerOnly ? (
            <div>
              {commonStore.state.displayModal && (
                <Fragment>
                  <app-main-modal
                    user={this.user}
                    isAutologged={this.isAutologged}
                    is-init-loading={this.loading}
                    do-print-screen={commonStore.state.displayModal}
                    data-html2canvas-ignore
                    hidden={!commonStore.state.displayModal}
                    host={this.hostElement}
                  ></app-main-modal>
                  <app-preview-record-modal
                    data-html2canvas-ignore
                    class={{ hide: !commonStore.state.displayVideoPreview }}
                  ></app-preview-record-modal>
                </Fragment>
              )}
            </div>
          ) : (
            <span class="hide"></span>
          )}
        </div>
      </Host>
    );
  }
}
